[
  {
    "name": "Desktop",
    "key": "base",
    "max_width": null,
    "previewer_width": 1450,
    "icon": "desktop",
    "hide_on_bigger_class": null,
    "hide_from_current_class": null
  },
  {
    "name": "Tablet",
    "key": "tab",
    "max_width": 1024,
    "icon": "tablet",
    "hide_on_bigger_class": "not-tab:hidden",
    "hide_from_current_class": "tab:hidden"
  },
  {
    "name": "Mobile",
    "key": "mob",
    "max_width": 640,
    "previewer_width": 402,
    "icon": "mobile",
    "hide_on_bigger_class": "not-mob:hidden",
    "hide_from_current_class": "mob:hidden"
  }
]
